import React, { useState } from 'react';
import { updateSettings } from '../../lib/api';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Plus, Save, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export const CommissionsTab = ({ settings, setSettings }) => {
    const [saving, setSaving] = useState(false);

    const handleTierChange = (index, field, value) => {
        const tiers = [...(settings.bonus_tiers || [])];
        tiers[index] = { ...tiers[index], [field]: Number(value) };
        setSettings((prev) => ({ ...prev, bonus_tiers: tiers }));
    };

    const handleAddTier = () => {
        setSettings((prev) => ({
            ...prev,
            bonus_tiers: [...(prev.bonus_tiers || []), { min: 0, max: 0, rate: 0, min_margin: 0.30 }]
        }));
    };

    const handleRemoveTier = (index) => {
        setSettings((prev) => ({ ...prev, bonus_tiers: (prev.bonus_tiers || []).filter((_, i) => i !== index) }));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await updateSettings({ bonus_tiers: settings.bonus_tiers });
            toast.success('Paramètres enregistrés');
        } catch {
            toast.error('Erreur lors de la sauvegarde');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="space-y-4">
            <div className="bg-white border border-[#E4E4E7] p-6 rounded-sm" data-testid="commissions-panel">
                <h3 className="font-semibold text-[#0A0A0A] mb-2">Paliers de commission commerciale</h3>
                <p className="text-sm text-[#52525B] mb-6">
                    Configurer les paliers de marge brute mensuelle et les taux de prime associés.
                    La marge minimum par défaut (en %) est requise pour déclencher la prime.
                </p>

                <div className="space-y-3">
                    <div className="grid grid-cols-12 gap-3 text-xs text-[#52525B] uppercase font-medium px-1">
                        <div className="col-span-3">Min (€)</div>
                        <div className="col-span-3">Max (€)</div>
                        <div className="col-span-2">Taux (%)</div>
                        <div className="col-span-3">Marge min (%)</div>
                        <div className="col-span-1"></div>
                    </div>
                    {(settings.bonus_tiers || []).map((tier, index) => (
                        <div key={`tier-${index}-${tier.min}-${tier.max}`} className="grid grid-cols-12 gap-3" data-testid={`tier-row-${index}`}>
                            <Input type="number" value={tier.min} onChange={(e) => handleTierChange(index, 'min', e.target.value)} className="h-10 rounded-sm col-span-3" />
                            <Input type="number" value={tier.max} onChange={(e) => handleTierChange(index, 'max', e.target.value)} className="h-10 rounded-sm col-span-3" />
                            <Input type="number" step="0.1" value={(tier.rate * 100).toFixed(1)} onChange={(e) => handleTierChange(index, 'rate', Number(e.target.value) / 100)} className="h-10 rounded-sm col-span-2" />
                            <Input type="number" step="1" value={(tier.min_margin * 100).toFixed(0)} onChange={(e) => handleTierChange(index, 'min_margin', Number(e.target.value) / 100)} className="h-10 rounded-sm col-span-3" />
                            <Button variant="ghost" size="icon" onClick={() => handleRemoveTier(index)} className="col-span-1 h-10 w-10">
                                <Trash2 className="w-4 h-4 text-red-500" />
                            </Button>
                        </div>
                    ))}
                </div>

                <div className="flex justify-between mt-6">
                    <Button variant="outline" onClick={handleAddTier} className="rounded-sm" data-testid="add-tier-btn">
                        <Plus className="w-4 h-4 mr-1" /> Ajouter un palier
                    </Button>
                    <Button
                        onClick={handleSave}
                        disabled={saving}
                        className="bg-[#E85A24] hover:bg-[#CC4D1C] text-white rounded-sm"
                        data-testid="save-tiers-btn"
                    >
                        <Save className="w-4 h-4 mr-2" /> Enregistrer
                    </Button>
                </div>
            </div>
        </div>
    );
};
